import React from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';

import {
    RouteWithLayout,
    PrivateRouteWithLayout,
    PreAuthRouteWithLayout
} from './components';

import {
    Main as MainLayout,
    Minimal as MinimalLayout
} from './layouts';

import {
    Login as LoginPage,
    Logout as LogoutPage,
    Register as RegisterPage,
    SyncSession as SyncSessionPage,
    RegistrationForm as RegistrationFormPage,

    InitPasswordReset as InitPasswordResetPage,
    PasswordReset as PasswordResetPage,
    TermsOfUse as TermsOfUsePage,
    PbdqAppShell,
    PbdqChatbot as PbdqChatbotPage,
    ChangePassword as ChangePasswordPage,
    ConfirmEmail as ConfirmEmailPage,
    Home as HomePage,
    NotFound as NotFoundPage,
    AppInfo as AppInfoPage,

    // ReportView as ReportPage,

    ViewCompanyInfo as ViewCompanyInfoPage,
    UpdateCompanyInfo as UpdateCompanyInfoPage,
    ListApplications as ListApplicationPage,
    CreateApplication as CreateApplicationPage,
    ApplicationDetail as ApplicationDetailPage,
    EditAppProgramDetail as EditAppProgramDetailPage,
    EnQaMode as EnQaModePage,
    DsQaMode as DsQaModePage,

    // DQProPages
    DQProHome as DQProHomePage,
    DQProCreate as DQProCreatePage,
    Support as SupportPage,
    ParentalConsent as ParentalConsentPage,
    DQProProducts as DQProProductsPage,
    DQProSalesResources as DQProSalesResourcesPage,
    DQProClientList as DQProClientListPage,
    DQProPeerList as DQProPeerListPage,
    DQProOnboarded as DQProOnboardedPage,
    DQProOnboardingHowToStart as DQProOnboardingHowToStartPage,
    DQProOnboardingWhatYouCanDo as DQProOnboardingWhatYouCanDoPage,
    DQProOnboardingWhatCanYouEarn as DQProOnboardingWhatCanYouEarnPage,
    DQProOnboardingRewards as DQProOnboardingRewardsPage,
    DQProLearnerProgramList as DQProLearnerProgramListPage,
    ProgramRequests as ProgramRequestsPage,
    SchoolProgramRequest as SchoolProgramRequestPage,
    DQProProgDashboard as DQProProgDashboardPage,
    DQProProgPreviewRedirect as DQProProgPreviewRedirectPage,
    DQProProgramDetails as DQProProgramDetailsPage,
    DQProProgOutline as DQProProgOutlinePage,
    LearnTab as DQProProgPreviewPage,
    DQProProgResources as DQProProgResourcesPage,
    DQProAssessments as DQProAssessmentsPage,
    DQProAssessmentName as DQProAssessmentNamePage,
    DQProCpciAssessmentSuite as DQProCpciAssessmentSuitePage,
    DQProPreviewAssessment as DQProPreviewAssessmentPage,
    DQProAssessmentResult as DQProAssessmentResultPage,
    DQProAssessmentList as DQProAssessmentListPage,
    DQProV2LearnCreator as DQProV2LearnCreatorPage,
    DQProProgCreationPreviewV2 as DQProProgCreationPreviewV2Page,
    DQProAlignment as DQProAlignmentPage,
    DQProSalesAnalytics as DQProSalesAnalyticsPage,
    DQProInsights as DQProInsightsPage,
    AccountSettings as AccountSettingsPage,
    DQProInvoiceList as DQProInvoiceListPage,
    DQProV2,
    DQProV2StepZero,
    DQProV2Login,
    DQProV2Signup,
    DQProV2Plans, TeacherDashboard, ManageClasses, ProfileChangeRequests, DQProV2ResetPassword,
    CurationPromptApplication,
    PbdqStatus,
    DqAiChatbotPreview,
    SolutionsOverview as SolutionsOverviewPage,
    SolutionReadinessOverview as SolutionReadinessOverviewPage,
    SolutionChildrenAssessmentOverview as SolutionChildrenAssessmentOverviewPage,
    SolutionChildrenAssessmentPreview as SolutionChildrenAssessmentPreviewPage,
    SolutionLearnCreatorOverview as SolutionLearnCreatorOverviewPage,
    SolutionLearnCreatorPreview as SolutionLearnCreatorPreviewPage,
} from './pages';

import {NationalAboutReadinessSolutionSection, NationalAboutAssessmentSection, NationalAboutScoresSection, NationalAboutReportSection, NationalPerformanceSummarySection, ExecutiveSummarySection, CompetencySection, CyberRisksSection, ParticipationSection, ContextEquitySection, ActionPlanSection, NationalPriorityActionsLearningProgramSection, NationalPriorityActionsSystemInterventionSection, NationalProgramDeploymentSection, NationalLearningImpactSection, NationalReassessmentSection, NationalMethodologySection, NationalMethodologyPriorityActionsSection, NationalMethodologyLearningImpactSection} from './pages/NationalDashboard';
import {AboutAssessmentSection, AboutRubricsScoresSection, AboutReportSection, AboutReadinessSolutionSection, MethodologyPriorityActionsSection, MethodologyLearningImpactSection, SummarySection, AttentionNeededSection, CountryClientSection, ProductsSection, ParticipationCoverageSection, PartnerCompetencySection, RiskQualitySection, MethodologySection, LearningDeploymentPage, LearningImpactPage, ReassessmentPage} from './pages/PartnerDashboard';
import {SchoolAboutReadinessSolutionSection, SchoolAboutAssessmentSection, SchoolAboutScoresSection, SchoolAboutReportSection, SchoolSummarySection, SchoolReadinessSection, SchoolCyberRisksSection, SchoolParticipationSection, SchoolContextEquitySection, SchoolContextSection, SchoolActionPlanSection, SchoolMethodologySection, SchoolMethodologyPriorityActionsSection, SchoolMethodologyLearningImpactSection, SchoolProgramDeploymentSection, SchoolLearningImpactSection, SchoolReassessmentSection, SchoolPriorityActionsLearningProgramSection, SchoolPriorityActionsSystemInterventionSection, SchoolProgramImpactSection} from './pages/SchoolDashboard';
import {NetworkAboutReadinessSolutionSection, NetworkAboutAssessmentSection, NetworkAboutScoresSection, NetworkAboutReportSection, NetworkSummarySection, NetworkReadinessSection, NetworkCyberRisksSection, NetworkContextSection, NetworkParticipationSection, NetworkPriorityActionsLearningProgramSection, NetworkPriorityActionsSystemInterventionSection, NetworkProgramDeploymentSection, NetworkLearningImpactSection, NetworkReassessmentSection, NetworkMethodologySection, NetworkMethodologyPriorityActionsSection, NetworkMethodologyLearningImpactSection} from './pages/NetworkDashboard';
import {IndividualScoreOverviewSection, IndividualCompetenciesSection, IndividualContextSupportSection, IndividualActionPlanSection, IndividualLearningProgressSection} from './pages/IndividualDashboard';
import {ClassExecutiveOverviewSection, ClassSummarySection, ClassReadinessSection, ClassParticipationSection, ClassContextEquitySection, ClassLearningDeploymentSection} from './pages/ClassDashboard';
import ProgramImpactSection from './pages/ProgramImpactDashboard/pages/ProgramImpact.page';
import SolutionGovernmentChecklistOverviewPage from './pages/DQPro/Solutions/SolutionGovernmentChecklistOverview.page';
import OpportunityPipelinePage from './pages/DQPro/GrowthOpportunities/OpportunityPipeline.page';
import SolutionAdoptionPage from './pages/DQPro/GrowthOpportunities/SolutionAdoption.page';
import MyProgramAdoptionPage from './pages/DQPro/GrowthOpportunities/MyProgramAdoption.page';
import PortfolioExecutiveOverviewPage from './pages/DQPro/GrowthOpportunities/PortfolioExecutiveOverview.page';
import PortfolioAttentionNeededPage from './pages/DQPro/GrowthOpportunities/PortfolioAttentionNeeded.page';
import PerformanceSummaryPage from './pages/DQPro/PerformanceSummary/PerformanceSummary.page';
import {CPCGovernmentLanding, CPCGovernmentLogin, CPCGovernmentDisclaimer, CPCGovernmentUserInfo, CPCGovernmentNationalOverview, CPCGovernmentChecklistExplorer, CPCGovernmentIndicatorDetail, CPCGovernmentReviewProgress} from './pages/CPCGovernmentDashboard';
import {
    GrowthOpportunitiesPlaceholder,
    LearnCreatorPlaceholder,
    SchoolNetworkDashboardPlaceholder,
    SolutionChildrenAssessmentPlaceholder,
    SolutionLearnCreatorPlaceholder,
    SolutionGovernmentChecklistPlaceholder,
    ProductAdoptionPlaceholder,
    PortfolioSnapshotPlaceholder,
    SolutionGovernmentChecklistPreviewPlaceholder,
} from './pages';

import CompanyInfoView from "./pages/CompanyInfo/View.page";
import SelectApplicationTypePage from "./pages/Application/SelectApplicationType.page";

// true for LOCAL (.env.local) and DEVELOP (.env.develop); false for STAGE and LIVE.
export const _isDevEnv = process.env.REACT_APP_NAME === 'LOCAL' || process.env.REACT_APP_NAME === 'DEVELOP';

const PublicSlidePreview = (props) => (
    <DQProV2LearnCreatorPage {...props} isPublicPreview={true} readOnly={true} />
);

const Routes = () => {
    return (
        <Switch>
            <Redirect
                exact
                from="/"
                to="/powered-by-dq"
            />
            <RouteWithLayout
                component={CurationPromptApplication}
                exact
                layout={MinimalLayout}
                path="/pbdq/apply"
            />
            <RouteWithLayout
                // Public: an application's status for its reference and contact email.
                component={PbdqStatus}
                exact
                layout={MinimalLayout}
                path="/pbdq/status"
            />
            <RouteWithLayout
                component={DqAiChatbotPreview}
                exact
                layout={MinimalLayout}
                path="/chatbot_preview"
            />
            {_isDevEnv && (
                <RouteWithLayout
                    component={PublicSlidePreview}
                    exact
                    layout={MinimalLayout}
                    path="/slide_preview/:code"
                />
            )}
            <RouteWithLayout
                component={CPCGovernmentLanding}
                exact
                layout={MinimalLayout}
                path="/dq_pro/cpc-government-dashboard"
            />
            <RouteWithLayout
                component={CPCGovernmentLogin}
                exact
                layout={MinimalLayout}
                path="/dq_pro/cpc-government-dashboard/login"
            />
            <RouteWithLayout
                component={CPCGovernmentDisclaimer}
                exact
                layout={MinimalLayout}
                path="/dq_pro/cpc-government-dashboard/disclaimer"
            />
            <RouteWithLayout
                component={CPCGovernmentUserInfo}
                exact
                layout={MinimalLayout}
                path="/dq_pro/cpc-government-dashboard/user-info"
            />
            <Redirect
                exact
                from="/dq_pro/cpc-government-dashboard/overview"
                to="/dq_pro/cpc-government-dashboard/overview/executive-summary"
            />
            <RouteWithLayout
                component={CPCGovernmentNationalOverview}
                exact
                layout={MinimalLayout}
                path="/dq_pro/cpc-government-dashboard/overview/executive-summary"
            />
            <RouteWithLayout
                component={CPCGovernmentNationalOverview}
                exact
                layout={MinimalLayout}
                path="/dq_pro/cpc-government-dashboard/overview/stakeholder-scores"
            />
            <RouteWithLayout
                component={CPCGovernmentNationalOverview}
                exact
                layout={MinimalLayout}
                path="/dq_pro/cpc-government-dashboard/overview/target-scores"
            />
            <RouteWithLayout
                component={CPCGovernmentChecklistExplorer}
                exact
                layout={MinimalLayout}
                path="/dq_pro/cpc-government-dashboard/explorer"
            />
            <RouteWithLayout
                component={CPCGovernmentIndicatorDetail}
                exact
                layout={MinimalLayout}
                path="/dq_pro/cpc-government-dashboard/explorer/:code"
            />
            <RouteWithLayout
                component={CPCGovernmentReviewProgress}
                exact
                layout={MinimalLayout}
                path="/dq_pro/cpc-government-dashboard/progress"
            />
            <RouteWithLayout
                component={DQProV2Signup}
                exact
                layout={MinimalLayout}
                path="/signup"
            />
            <RouteWithLayout
                component={DQProV2Login}
                exact
                layout={MinimalLayout}
                path="/login"
            />
            <PreAuthRouteWithLayout
                component={RegisterPage}
                exact
                layout={MinimalLayout}
                path="/register"
            />
            <PreAuthRouteWithLayout
                component={SyncSessionPage}
                exact
                layout={MinimalLayout}
                path="/sync_session"
            />

            <PreAuthRouteWithLayout
                component={InitPasswordResetPage}
                exact
                layout={MinimalLayout}
                path="/account/recover"
            />
            <PreAuthRouteWithLayout
                component={PasswordResetPage}
                exact
                layout={MinimalLayout}
                no_redirect={true}
                path="/auth/reset/password"
            />

            <PreAuthRouteWithLayout
                component={TermsOfUsePage}
                exact
                layout={MinimalLayout}
                no_redirect={true}
                path="/terms-of-use"
            />

            {/* Powered by DQ — public marketing site. /chatbot is a fixed
                destination (email/payment-return deep links point at it
                directly) so it stays its own route, matched before the
                broader shell prefix below. Every other /powered-by-dq/*
                page is hosted inside PbdqAppShell, behind one shared DQ
                Agent chat provider that survives navigation between them. */}
            <PreAuthRouteWithLayout
                component={PbdqChatbotPage}
                exact
                layout={MinimalLayout}
                no_redirect={true}
                path="/powered-by-dq/chatbot"
            />
            <Route
                component={PbdqAppShell}
                path="/powered-by-dq"
            />

            <PrivateRouteWithLayout
                component={ConfirmEmailPage}
                exact
                layout={MinimalLayout}
                path="/auth/confirm/email"
            />
            <PrivateRouteWithLayout
                component={DQProHomePage}
                exact
                layout={MainLayout}
                path="/home"
            />
            {/*<PrivateRouteWithLayout*/}
            {/*    component={ReportPage}*/}
            {/*    exact*/}
            {/*    layout={MainLayout}*/}
            {/*    path="/report"*/}
            {/*/>*/}
            <PrivateRouteWithLayout
                component={ViewCompanyInfoPage}
                exact
                layout={MainLayout}
                path="/company/view"
            />
            <PrivateRouteWithLayout
                component={UpdateCompanyInfoPage}
                exact
                layout={MainLayout}
                path="/company/update"
            />
            <PrivateRouteWithLayout
                component={ListApplicationPage}
                exact
                layout={MainLayout}
                path="/application/list"
            />
            <PrivateRouteWithLayout
                component={ApplicationDetailPage}
                exact
                layout={MainLayout}
                path="/application/detail"
            />
            <PrivateRouteWithLayout
                component={EditAppProgramDetailPage}
                exact
                layout={MainLayout}
                path="/application/edit/program"
            />
            <PrivateRouteWithLayout
                component={CreateApplicationPage}
                exact
                layout={MainLayout}
                path="/application/create"
            />


            <PrivateRouteWithLayout
                component={ChangePasswordPage}
                exact
                layout={MainLayout}
                path="/password/change"
            />
            {/*
              * PbDQ navigation destinations whose screens are not built yet.
              * Named pages rather than missing routes, so the workspace
              * structure can be reviewed without dead links.
              */}
            <PrivateRouteWithLayout
                component={SolutionsOverviewPage}
                exact
                layout={MainLayout}
                path="/dq_pro/solutions"
            />
            <PrivateRouteWithLayout
                component={GrowthOpportunitiesPlaceholder}
                exact
                layout={MainLayout}
                path="/dq_pro/growth-opportunities"
            />
            <PrivateRouteWithLayout
                component={LearnCreatorPlaceholder}
                exact
                layout={MainLayout}
                path="/dq_pro/learncreator"
            />
            <PrivateRouteWithLayout
                component={SchoolNetworkDashboardPlaceholder}
                exact
                layout={MainLayout}
                path="/dq_pro/school-network-dashboard"
            />
            <PrivateRouteWithLayout
                component={ProgramImpactSection}
                exact
                layout={MainLayout}
                path="/dq_pro/program-impact-dashboard"
            />
            <PrivateRouteWithLayout
                component={ProgramImpactSection}
                exact
                layout={MainLayout}
                path="/dq_pro/lc-program-impact-dashboard"
            />
            <PrivateRouteWithLayout
                component={PerformanceSummaryPage}
                exact
                layout={MainLayout}
                path="/dq_pro/performance-summary"
            />
            {/* Level 2 — Solutions. Common Section pages, shared by PW, SW and TW. */}
            <PrivateRouteWithLayout
                component={SolutionsOverviewPage}
                exact
                layout={MainLayout}
                path="/dq_pro/solutions/overview"
            />
            <PrivateRouteWithLayout
                component={SolutionReadinessOverviewPage}
                exact
                layout={MainLayout}
                path="/dq_pro/solutions/readiness"
            />
            <PrivateRouteWithLayout
                component={SolutionChildrenAssessmentPlaceholder}
                exact
                layout={MainLayout}
                path="/dq_pro/solutions/children-assessment"
            />
            <PrivateRouteWithLayout
                component={SolutionLearnCreatorPlaceholder}
                exact
                layout={MainLayout}
                path="/dq_pro/solutions/learncreator"
            />
            <PrivateRouteWithLayout
                component={SolutionGovernmentChecklistPlaceholder}
                exact
                layout={MainLayout}
                path="/dq_pro/solutions/government-checklist"
            />
            {/* Level 2 — Growth Opportunities. Opportunity Pipeline reuses the real requests page. */}
            <PrivateRouteWithLayout
                component={ProductAdoptionPlaceholder}
                exact
                layout={MainLayout}
                path="/dq_pro/growth-opportunities/product-adoption"
            />
            <PrivateRouteWithLayout
                component={PortfolioSnapshotPlaceholder}
                exact
                layout={MainLayout}
                path="/dq_pro/growth-opportunities/portfolio-snapshot"
            />
            <PrivateRouteWithLayout
                component={OpportunityPipelinePage}
                exact
                layout={MainLayout}
                path="/dq_pro/growth-opportunities/pipeline"
            />
            {/*
              * Level 3 — each solution's Overview / Preview. Sidebar rows, not
              * tabs: the sheet gives Level 3 its own code and name columns and
              * keeps Tab Code / Tab Name for the Settings page.
              *
              * COS Readiness Solution has no Preview — the sheet lists none.
              */}
            <PrivateRouteWithLayout
                component={SolutionReadinessOverviewPage}
                exact
                layout={MainLayout}
                path="/dq_pro/solutions/readiness/overview"
            />
            <PrivateRouteWithLayout
                component={SolutionChildrenAssessmentOverviewPage}
                exact
                layout={MainLayout}
                path="/dq_pro/solutions/children-assessment/overview"
            />
            <PrivateRouteWithLayout
                component={SolutionChildrenAssessmentPreviewPage}
                exact
                layout={MainLayout}
                path="/dq_pro/solutions/children-assessment/preview"
            />
            <PrivateRouteWithLayout
                component={SolutionLearnCreatorOverviewPage}
                exact
                layout={MainLayout}
                path="/dq_pro/solutions/learncreator/overview"
            />
            <PrivateRouteWithLayout
                component={SolutionLearnCreatorPreviewPage}
                exact
                layout={MainLayout}
                path="/dq_pro/solutions/learncreator/preview"
            />
            <PrivateRouteWithLayout
                component={SolutionGovernmentChecklistOverviewPage}
                exact
                layout={MainLayout}
                path="/dq_pro/solutions/government-checklist/overview"
            />
            <PrivateRouteWithLayout
                component={SolutionGovernmentChecklistPreviewPlaceholder}
                exact
                layout={MainLayout}
                path="/dq_pro/solutions/government-checklist/preview"
            />
            {/* Level 3 — Product Adoption. My Program Adoption is tagged P1B, LC. */}
            <PrivateRouteWithLayout
                component={SolutionAdoptionPage}
                exact
                layout={MainLayout}
                path="/dq_pro/growth-opportunities/product-adoption/solution-adoption"
            />
            <PrivateRouteWithLayout
                component={MyProgramAdoptionPage}
                exact
                layout={MainLayout}
                path="/dq_pro/growth-opportunities/product-adoption/my-program-adoption"
            />
            {/* Level 3 — Portfolio Snapshot. Sheet rows 24-27 name these but give no codes. */}
            <PrivateRouteWithLayout
                component={PortfolioExecutiveOverviewPage}
                exact
                layout={MainLayout}
                path="/dq_pro/growth-opportunities/portfolio-snapshot/executive-overview"
            />
            <PrivateRouteWithLayout
                component={PortfolioAttentionNeededPage}
                exact
                layout={MainLayout}
                path="/dq_pro/growth-opportunities/portfolio-snapshot/attention-needed"
            />
            <PrivateRouteWithLayout
                component={LogoutPage}
                exact
                layout={MainLayout}
                path="/logout"
            />

            <PrivateRouteWithLayout
                component={SelectApplicationTypePage}
                exact
                layout={MainLayout}
                path="/application/select"
            />


            {/*########################*/}
            {/*### DQPro -- ROUTES ###*/}
            {/*########################*/}


            <RouteWithLayout
                component={DQProV2}
                exact
                layout={MinimalLayout}
                path="/dq_pro/home"
            />

            {/*
              * Step 0 of the LearnCreator flow — the same layout as the public
              * page, with the slide-4 additions, for a signed-in user arriving
              * from Solutions > LearnCreator > Create a Program. Private, because
              * unlike /dq_pro/home it is never the anonymous front door.
              */}
            <PrivateRouteWithLayout
                component={DQProV2StepZero}
                exact
                layout={MinimalLayout}
                path="/dq_pro/learncreator/start"
            />
            <PrivateRouteWithLayout
                component={DQProOnboardedPage}
                exact
                layout={MainLayout}
                path="/dq_pro/onboarded"
            />
            <PrivateRouteWithLayout
                component={DQProOnboardingHowToStartPage}
                exact
                layout={MainLayout}
                path="/dq_pro/onboarded/how-to-start"
            />
            <PrivateRouteWithLayout
                component={DQProOnboardingWhatYouCanDoPage}
                exact
                layout={MainLayout}
                path="/dq_pro/onboarded/what-you-can-do"
            />
            <PrivateRouteWithLayout
                component={DQProOnboardingWhatCanYouEarnPage}
                exact
                layout={MainLayout}
                path="/dq_pro/onboarded/what-can-you-earn"
            />
            {/*<PrivateRouteWithLayout*/}
            {/*    component={DQProOnboardingRewardsPage}*/}
            {/*    exact*/}
            {/*    layout={MainLayout}*/}
            {/*    path="/dq_pro/onboarded/rewards"*/}
            {/*/>*/}
            <PrivateRouteWithLayout
                component={DQProProductsPage}
                exact
                layout={MainLayout}
                path="/dq_pro/products"
            />
            {/* The assessment details page (Edit Info / Preview cards) was removed
                (Ian, 13 Oct 2026): its address now opens the preview. */}
            <Redirect exact from="/dq_pro/product/view/:code" to="/dq_pro/product/view/:code/preview" />
            <PrivateRouteWithLayout
                component={DQProAssessmentsPage}
                exact
                layout={MainLayout}
                path="/dq_pro/products/assessments"
            />
            <PrivateRouteWithLayout
                component={DQProAssessmentNamePage}
                exact
                layout={MainLayout}
                path="/dq_pro/products/assessments/name"
            />
            {/* COS has no creation step: it is pre-created for plans that include
                it (backend ensureCosAssessmentsForInsider), so the old build flow
                sends people to the assessment list where it already is. */}
            <Redirect
                exact
                from="/dq_pro/products/cpci/assessments"
                to="/dq_pro/assessment/list"
            />
            <Redirect
                exact
                from="/dq_pro/products/cpci/assessments/name"
                to="/dq_pro/assessment/list"
            />
            <PrivateRouteWithLayout
                component={DQProCpciAssessmentSuitePage}
                exact
                layout={MainLayout}
                path="/dq_pro/products/cpci/suite"
            />
            <PrivateRouteWithLayout
                component={DQProPreviewAssessmentPage}
                exact
                layout={MainLayout}
                path="/dq_pro/product/view/:code/preview"
            />
            <PrivateRouteWithLayout
                component={DQProAssessmentResultPage}
                exact
                layout={MainLayout}
                path="/dq_pro/products/assessments/result"
            />
            <PrivateRouteWithLayout
                component={DQProSalesResourcesPage}
                exact
                layout={MainLayout}
                path="/dq_pro/sales/resources"
            />
            <PrivateRouteWithLayout
                component={DQProClientListPage}
                exact
                layout={MainLayout}
                path="/dq_pro/clients/list"
            />
            <PrivateRouteWithLayout
                component={DQProPeerListPage}
                exact
                layout={MainLayout}
                path="/dq_pro/peers/list"
            />
            <PrivateRouteWithLayout
                component={DQProAssessmentListPage}
                exact
                layout={MainLayout}
                path="/dq_pro/assessment/list"
            />
            <Redirect
                exact
                from="/dq_pro/program/creation"
                to="/dq_pro/program/creation/preview"
            />
            {/* P1 Workspace — owner views Learning Program Requests from schools. */}
            <PrivateRouteWithLayout
                component={ProgramRequestsPage}
                exact
                layout={MainLayout}
                path="/dq_pro/program/requests"
            />
            {/* P1 Workspace — school raises a Learning Program request. */}
            <PrivateRouteWithLayout
                component={SchoolProgramRequestPage}
                exact
                layout={MainLayout}
                path="/dq_pro/program/request"
            />
            <Redirect
                exact
                from="/dq_pro/program/creation/copy"
                to="/dq_pro/program/creation/preview"
            />
            <Redirect
                exact
                from="/dq_pro/program/creation/v2"
                to="/dq_pro/program/creation/preview"
            />
            <PrivateRouteWithLayout
                component={DQProHomePage}
                exact
                layout={MainLayout}
                path="/my_workspace"
            />
            <PrivateRouteWithLayout
                component={DQProCreatePage}
                exact
                layout={MainLayout}
                path="/dq_pro/create"
            />
            <PrivateRouteWithLayout
                component={SupportPage}
                exact
                layout={MainLayout}
                path="/support"
            />
            <PrivateRouteWithLayout
                component={ParentalConsentPage}
                exact
                layout={MainLayout}
                path="/dq_pro/parental-consent"
            />
            <PrivateRouteWithLayout
                component={DQProV2LearnCreatorPage}
                exact
                layout={MinimalLayout}
                path="/dq_pro/program/creation/preview"
            />
            <PreAuthRouteWithLayout
                component={LoginPage}
                exact
                layout={MinimalLayout}
                path="/login-v2"
            />
            <PreAuthRouteWithLayout
                component={RegistrationFormPage}
                exact
                layout={MinimalLayout}
                path="/signup-v2"
            />
            <RouteWithLayout
                component={DQProV2ResetPassword}
                exact
                layout={MinimalLayout}
                path="/reset-password"
            />

            <RouteWithLayout
                component={DQProV2Plans}
                exact
                layout={MinimalLayout}
                path="/pbdq-plans"
            />
            <PrivateRouteWithLayout
                component={DQProAlignmentPage}
                exact
                layout={MainLayout}
                path="/dq_pro/alignment"
            />
            <PrivateRouteWithLayout
                component={DQProSalesAnalyticsPage}
                exact
                layout={MainLayout}
                path="/dq_pro/sales-analytics"
            />
            <PrivateRouteWithLayout
                component={DQProInsightsPage}
                exact
                layout={MainLayout}
                path="/dq_pro/insights"
            />
            <PrivateRouteWithLayout
                component={AccountSettingsPage}
                exact
                layout={MainLayout}
                path="/account/settings"
            />
            <PrivateRouteWithLayout
                component={DQProInvoiceListPage}
                exact
                layout={MainLayout}
                path="/dq_pro/invoices/list"
            />
            <PrivateRouteWithLayout
                component={DQProLearnerProgramListPage}
                exact
                layout={MainLayout}
                path="/dq_pro/learning/program/list"
            />
            <Redirect
                exact
                from="/dq_pro/products/program/name"
                to="/dq_pro/program/creation/preview"
            />

            <PrivateRouteWithLayout
                component={DQProProgDashboardPage}
                exact
                layout={MainLayout}
                path="/dq_pro/products/program/dashboard/:code"
            />
            <PrivateRouteWithLayout
                component={DQProProgramDetailsPage}
                exact
                layout={MainLayout}
                path="/dq_pro/products/program/view/:code"
            />
            <PrivateRouteWithLayout
                component={DQProProgOutlinePage}
                exact
                layout={MainLayout}
                path="/dq_pro/products/program/:code/outline"
            />
            {/* Opening a program skips its dashboard and goes straight to the
                preview. The dashboard route above is kept but no longer linked. */}
            <PrivateRouteWithLayout
                component={DQProProgPreviewRedirectPage}
                exact
                layout={MinimalLayout}
                path="/dq_pro/products/program/:code/preview"
            />
            <PrivateRouteWithLayout
                component={DQProProgResourcesPage}
                exact
                layout={MainLayout}
                path="/dq_pro/products/program/:code/resources"
            />
            <PrivateRouteWithLayout
                component={TeacherDashboard}
                exact
                layout={MinimalLayout}
                path="/dq_pro/teacher-dashboard"
            />
            {/*########################*/}
            {/*### Miscellaneous -- ROUTES ###*/}
            {/*########################*/}

            <RouteWithLayout
                component={AppInfoPage}
                exact={false}
                layout={MinimalLayout}
                path="/app_info"
            />

            <RouteWithLayout
                component={EnQaModePage}
                exact={false}
                layout={MinimalLayout}
                path="/en_qa_mode"
            />

            <RouteWithLayout
                component={DsQaModePage}
                exact={false}
                layout={MinimalLayout}
                path="/ds_qa_mode"
            />

            <PrivateRouteWithLayout
                component={ManageClasses}
                exact
                layout={MainLayout}
                path="/dq_pro/classes"
            />

            {/* Learner corrections awaiting the school. Sits beside My
                Classes because it is the same audience and the same
                scope: this school's own learners. */}
            <PrivateRouteWithLayout
                component={ProfileChangeRequests}
                exact
                layout={MainLayout}
                path="/dq_pro/profile-change-requests"
            />

            {/*########################*/}
            {/*### Partner Dashboard -- ROUTES ###*/}
            {/*########################*/}

            <PrivateRouteWithLayout
                component={AboutAssessmentSection}
                exact
                layout={MainLayout}
                path="/dq_pro/partner-dashboard/overview/about-assessment"
            />
            <PrivateRouteWithLayout
                component={AboutRubricsScoresSection}
                exact
                layout={MainLayout}
                path="/dq_pro/partner-dashboard/overview/about-rubrics-scores"
            />
            <PrivateRouteWithLayout
                component={AboutReportSection}
                exact
                layout={MainLayout}
                path="/dq_pro/partner-dashboard/overview/about-report"
            />
            <PrivateRouteWithLayout
                component={AboutReadinessSolutionSection}
                exact
                layout={MainLayout}
                path="/dq_pro/partner-dashboard/overview/about-readiness-solution"
            />
            {/* Lands on About COS Readiness Solution, like the School and Network
                dashboards (LA-PD-08Oct-1); a P0 plan is sent on from there. */}
            <Redirect
                exact
                from="/dq_pro/partner-dashboard/overview"
                to="/dq_pro/partner-dashboard/overview/about-readiness-solution"
            />
            <PrivateRouteWithLayout
                component={SummarySection}
                exact
                layout={MainLayout}
                path="/dq_pro/partner-dashboard/summary"
            />
            <PrivateRouteWithLayout
                component={AttentionNeededSection}
                exact
                layout={MainLayout}
                path="/dq_pro/partner-dashboard/attention-needed"
            />
            <PrivateRouteWithLayout
                component={CountryClientSection}
                exact
                layout={MainLayout}
                path="/dq_pro/partner-dashboard/country-client"
            />
            {/* P1 Partner Dashboard deck: Learning Deployment (21-23),
                Learning Impact (24-26) and Reassessment (27-28). Real routes
                so the sections exist where the deck says they do; each states
                that its data is not flowing yet. */}
            <PrivateRouteWithLayout
                component={LearningDeploymentPage}
                exact
                layout={MainLayout}
                path="/dq_pro/partner-dashboard/learning-deployment"
            />
            <PrivateRouteWithLayout
                component={LearningImpactPage}
                exact
                layout={MainLayout}
                path="/dq_pro/partner-dashboard/learning-impact"
            />
            <PrivateRouteWithLayout
                component={ReassessmentPage}
                exact
                layout={MainLayout}
                path="/dq_pro/partner-dashboard/reassessment"
            />
            <PrivateRouteWithLayout
                component={ProductsSection}
                exact
                layout={MainLayout}
                path="/dq_pro/partner-dashboard/products"
            />
            <PrivateRouteWithLayout
                component={ParticipationCoverageSection}
                exact
                layout={MainLayout}
                path="/dq_pro/partner-dashboard/participation-coverage"
            />
            <PrivateRouteWithLayout
                component={PartnerCompetencySection}
                exact
                layout={MainLayout}
                path="/dq_pro/partner-dashboard/competency"
            />
            <PrivateRouteWithLayout
                component={RiskQualitySection}
                exact
                layout={MainLayout}
                path="/dq_pro/partner-dashboard/risk-quality"
            />
            <PrivateRouteWithLayout
                component={MethodologySection}
                exact
                layout={MainLayout}
                path="/dq_pro/partner-dashboard/methodology"
            />
            <PrivateRouteWithLayout
                component={MethodologyPriorityActionsSection}
                exact
                layout={MainLayout}
                path="/dq_pro/partner-dashboard/methodology/priority-actions"
            />
            <PrivateRouteWithLayout
                component={MethodologyLearningImpactSection}
                exact
                layout={MainLayout}
                path="/dq_pro/partner-dashboard/methodology/learning-impact"
            />


            {/*########################*/}
            {/*### Class Dashboard -- ROUTES ###*/}
            {/*########################*/}

            <PrivateRouteWithLayout
                component={ClassExecutiveOverviewSection}
                exact
                layout={MainLayout}
                path="/dq_pro/class-dashboard/executive-overview"
            />
            <PrivateRouteWithLayout
                component={ClassSummarySection}
                exact
                layout={MainLayout}
                path="/dq_pro/class-dashboard/summary"
            />
            <PrivateRouteWithLayout
                component={ClassReadinessSection}
                exact
                layout={MainLayout}
                path="/dq_pro/class-dashboard/readiness"
            />
            <PrivateRouteWithLayout
                component={ClassParticipationSection}
                exact
                layout={MainLayout}
                path="/dq_pro/class-dashboard/participation"
            />
            <PrivateRouteWithLayout
                component={ClassContextEquitySection}
                exact
                layout={MainLayout}
                path="/dq_pro/class-dashboard/context-equity"
            />
            <PrivateRouteWithLayout
                component={ClassLearningDeploymentSection}
                exact
                layout={MainLayout}
                path="/dq_pro/class-dashboard/learning-deployment"
            />
            {/* Keep ?section_code= on the way to the landing page — a plain string Redirect drops the
                query, and the Class dashboard needs the class code (QA 9 Oct, LA-CD-1). */}
            <Route
                exact
                path="/dq_pro/class-dashboard"
                render={({location}) => <Redirect to={{pathname: '/dq_pro/class-dashboard/executive-overview', search: location.search}}/>}
            />

            {/*########################*/}
            {/*### Network Dashboard -- ROUTES ###*/}
            {/*########################*/}

            <PrivateRouteWithLayout
                component={NetworkAboutReadinessSolutionSection}
                exact
                layout={MainLayout}
                path="/dq_pro/network-dashboard/overview/about-readiness-solution"
            />
            <PrivateRouteWithLayout
                component={NetworkAboutAssessmentSection}
                exact
                layout={MainLayout}
                path="/dq_pro/network-dashboard/overview/about-assessment"
            />
            <PrivateRouteWithLayout
                component={NetworkAboutScoresSection}
                exact
                layout={MainLayout}
                path="/dq_pro/network-dashboard/overview/about-scores"
            />
            <PrivateRouteWithLayout
                component={NetworkAboutReportSection}
                exact
                layout={MainLayout}
                path="/dq_pro/network-dashboard/overview/about-report"
            />
            <PrivateRouteWithLayout
                component={NetworkSummarySection}
                exact
                layout={MainLayout}
                path="/dq_pro/network-dashboard/executive-summary"
            />
            <PrivateRouteWithLayout
                component={NetworkReadinessSection}
                exact
                layout={MainLayout}
                path="/dq_pro/network-dashboard/readiness"
            />
            <PrivateRouteWithLayout
                component={NetworkCyberRisksSection}
                exact
                layout={MainLayout}
                path="/dq_pro/network-dashboard/cyber-risks"
            />
            <PrivateRouteWithLayout
                component={NetworkContextSection}
                exact
                layout={MainLayout}
                path="/dq_pro/network-dashboard/context-support"
            />
            <PrivateRouteWithLayout
                component={NetworkParticipationSection}
                exact
                layout={MainLayout}
                path="/dq_pro/network-dashboard/participation"
            />
            <PrivateRouteWithLayout
                component={NetworkPriorityActionsLearningProgramSection}
                exact
                layout={MainLayout}
                path="/dq_pro/network-dashboard/priority-actions/learning-program"
            />
            <PrivateRouteWithLayout
                component={NetworkPriorityActionsSystemInterventionSection}
                exact
                layout={MainLayout}
                path="/dq_pro/network-dashboard/priority-actions/system-intervention"
            />
            <PrivateRouteWithLayout
                component={NetworkProgramDeploymentSection}
                exact
                layout={MainLayout}
                path="/dq_pro/network-dashboard/learning-programs/learning-deployment"
            />
            <PrivateRouteWithLayout
                component={NetworkLearningImpactSection}
                exact
                layout={MainLayout}
                path="/dq_pro/network-dashboard/learning-programs/learning-impact"
            />
            <PrivateRouteWithLayout
                component={NetworkReassessmentSection}
                exact
                layout={MainLayout}
                path="/dq_pro/network-dashboard/reassessment"
            />
            <PrivateRouteWithLayout
                component={NetworkMethodologySection}
                exact
                layout={MainLayout}
                path="/dq_pro/network-dashboard/methodology"
            />
            <PrivateRouteWithLayout
                component={NetworkMethodologyPriorityActionsSection}
                exact
                layout={MainLayout}
                path="/dq_pro/network-dashboard/methodology/priority-actions"
            />
            <PrivateRouteWithLayout
                component={NetworkMethodologyLearningImpactSection}
                exact
                layout={MainLayout}
                path="/dq_pro/network-dashboard/methodology/learning-impact"
            />
            <Redirect
                exact
                from="/dq_pro/network-dashboard/overview"
                to="/dq_pro/network-dashboard/overview/about-readiness-solution"
            />
            <Redirect
                exact
                from="/dq_pro/network-dashboard"
                to="/dq_pro/network-dashboard/overview/about-readiness-solution"
            />

            {/*########################*/}
            {/*### School Dashboard -- ROUTES ###*/}
            {/*########################*/}

            <PrivateRouteWithLayout
                component={SchoolAboutReadinessSolutionSection}
                exact
                layout={MainLayout}
                path="/dq_pro/school-dashboard/overview/about-readiness-solution"
            />
            <PrivateRouteWithLayout
                component={SchoolAboutAssessmentSection}
                exact
                layout={MainLayout}
                path="/dq_pro/school-dashboard/overview/about-assessment"
            />
            <PrivateRouteWithLayout
                component={SchoolAboutScoresSection}
                exact
                layout={MainLayout}
                path="/dq_pro/school-dashboard/overview/about-scores"
            />
            <PrivateRouteWithLayout
                component={SchoolAboutReportSection}
                exact
                layout={MainLayout}
                path="/dq_pro/school-dashboard/overview/about-report"
            />
            <PrivateRouteWithLayout
                component={SchoolSummarySection}
                exact
                layout={MainLayout}
                path="/dq_pro/school-dashboard/executive-summary"
            />
            <PrivateRouteWithLayout
                component={SchoolReadinessSection}
                exact
                layout={MainLayout}
                path="/dq_pro/school-dashboard/readiness"
            />
            <PrivateRouteWithLayout
                component={SchoolCyberRisksSection}
                exact
                layout={MainLayout}
                path="/dq_pro/school-dashboard/cyber-risks"
            />
            <PrivateRouteWithLayout
                component={SchoolParticipationSection}
                exact
                layout={MainLayout}
                path="/dq_pro/school-dashboard/participation"
            />
            <PrivateRouteWithLayout
                component={SchoolContextSection}
                exact
                layout={MainLayout}
                path="/dq_pro/school-dashboard/context-support"
            />
            <PrivateRouteWithLayout
                component={SchoolActionPlanSection}
                exact
                layout={MainLayout}
                path="/dq_pro/school-dashboard/action-plan"
            />
            <PrivateRouteWithLayout
                component={SchoolMethodologySection}
                exact
                layout={MainLayout}
                path="/dq_pro/school-dashboard/methodology"
            />
            <PrivateRouteWithLayout
                component={SchoolMethodologyPriorityActionsSection}
                exact
                layout={MainLayout}
                path="/dq_pro/school-dashboard/methodology/priority-actions"
            />
            <PrivateRouteWithLayout
                component={SchoolMethodologyLearningImpactSection}
                exact
                layout={MainLayout}
                path="/dq_pro/school-dashboard/methodology/learning-impact"
            />
            <PrivateRouteWithLayout
                component={SchoolProgramDeploymentSection}
                exact
                layout={MainLayout}
                path="/dq_pro/school-dashboard/learning-programs/learning-deployment"
            />
            <PrivateRouteWithLayout
                component={SchoolLearningImpactSection}
                exact
                layout={MainLayout}
                path="/dq_pro/school-dashboard/learning-programs/learning-impact"
            />
            <PrivateRouteWithLayout
                component={SchoolProgramImpactSection}
                exact
                layout={MainLayout}
                path="/dq_pro/school-dashboard/learning-programs/learning-impact/program-impact"
            />
            <PrivateRouteWithLayout
                component={SchoolReassessmentSection}
                exact
                layout={MainLayout}
                path="/dq_pro/school-dashboard/reassessment"
            />
            <PrivateRouteWithLayout
                component={SchoolPriorityActionsLearningProgramSection}
                exact
                layout={MainLayout}
                path="/dq_pro/school-dashboard/priority-actions/learning-program"
            />
            <PrivateRouteWithLayout
                component={SchoolPriorityActionsSystemInterventionSection}
                exact
                layout={MainLayout}
                path="/dq_pro/school-dashboard/priority-actions/system-intervention"
            />
            <Redirect
                exact
                from="/dq_pro/school-dashboard/overview"
                to="/dq_pro/school-dashboard/overview/about-readiness-solution"
            />
            <Redirect
                exact
                from="/dq_pro/school-dashboard"
                to="/dq_pro/school-dashboard/overview/about-readiness-solution"
            />

            {/*########################*/}
            {/*### Individual Dashboard -- ROUTES ###*/}
            {/*########################*/}

            <PrivateRouteWithLayout
                component={IndividualScoreOverviewSection}
                exact
                layout={MainLayout}
                path="/dq_pro/individual-dashboard/score-overview"
            />
            <PrivateRouteWithLayout
                component={IndividualCompetenciesSection}
                exact
                layout={MainLayout}
                path="/dq_pro/individual-dashboard/competencies"
            />
            <PrivateRouteWithLayout
                component={IndividualContextSupportSection}
                exact
                layout={MainLayout}
                path="/dq_pro/individual-dashboard/context-support"
            />
            <PrivateRouteWithLayout
                component={IndividualActionPlanSection}
                exact
                layout={MainLayout}
                path="/dq_pro/individual-dashboard/action-plan"
            />
            <PrivateRouteWithLayout
                component={IndividualLearningProgressSection}
                exact
                layout={MainLayout}
                path="/dq_pro/individual-dashboard/learning-progress"
            />
            <Redirect
                exact
                from="/dq_pro/individual-dashboard"
                to="/dq_pro/individual-dashboard/score-overview"
            />

            {/*########################*/}
            {/*### National Dashboard -- ROUTES ###*/}
            {/*########################*/}

            <PrivateRouteWithLayout
                component={NationalAboutReadinessSolutionSection}
                exact
                layout={MainLayout}
                path="/dq_pro/national-dashboard/overview/about-readiness-solution"
            />
            <PrivateRouteWithLayout
                component={NationalAboutAssessmentSection}
                exact
                layout={MainLayout}
                path="/dq_pro/national-dashboard/overview/about-assessment"
            />
            <PrivateRouteWithLayout
                component={NationalAboutScoresSection}
                exact
                layout={MainLayout}
                path="/dq_pro/national-dashboard/overview/about-scores"
            />
            <PrivateRouteWithLayout
                component={NationalAboutReportSection}
                exact
                layout={MainLayout}
                path="/dq_pro/national-dashboard/overview/about-report"
            />
            <Redirect
                exact
                from="/dq_pro/national-dashboard/overview"
                to="/dq_pro/national-dashboard/overview/about-readiness-solution"
            />
            <PrivateRouteWithLayout
                component={NationalPerformanceSummarySection}
                exact
                layout={MainLayout}
                path="/dq_pro/national-dashboard/performance-summary"
            />
            <PrivateRouteWithLayout
                component={ExecutiveSummarySection}
                exact
                layout={MainLayout}
                path="/dq_pro/national-dashboard/summary"
            />
            <PrivateRouteWithLayout
                component={CompetencySection}
                exact
                layout={MainLayout}
                path="/dq_pro/national-dashboard/competency"
            />
            <PrivateRouteWithLayout
                component={CyberRisksSection}
                exact
                layout={MainLayout}
                path="/dq_pro/national-dashboard/cyber-risks"
            />
            <PrivateRouteWithLayout
                component={ParticipationSection}
                exact
                layout={MainLayout}
                path="/dq_pro/national-dashboard/participation"
            />
            <PrivateRouteWithLayout
                component={ContextEquitySection}
                exact
                layout={MainLayout}
                path="/dq_pro/national-dashboard/context-equity"
            />
            <PrivateRouteWithLayout
                component={ActionPlanSection}
                exact
                layout={MainLayout}
                path="/dq_pro/national-dashboard/action-plan"
            />
            <PrivateRouteWithLayout
                component={NationalPriorityActionsLearningProgramSection}
                exact
                layout={MainLayout}
                path="/dq_pro/national-dashboard/priority-actions/learning-program"
            />
            <PrivateRouteWithLayout
                component={NationalPriorityActionsSystemInterventionSection}
                exact
                layout={MainLayout}
                path="/dq_pro/national-dashboard/priority-actions/system-intervention"
            />
            <PrivateRouteWithLayout
                component={NationalProgramDeploymentSection}
                exact
                layout={MainLayout}
                path="/dq_pro/national-dashboard/learning-programs/learning-deployment"
            />
            <PrivateRouteWithLayout
                component={NationalLearningImpactSection}
                exact
                layout={MainLayout}
                path="/dq_pro/national-dashboard/learning-programs/learning-impact"
            />
            <PrivateRouteWithLayout
                component={NationalReassessmentSection}
                exact
                layout={MainLayout}
                path="/dq_pro/national-dashboard/reassessment"
            />
            <PrivateRouteWithLayout
                component={NationalMethodologySection}
                exact
                layout={MainLayout}
                path="/dq_pro/national-dashboard/methodology"
            />
            <PrivateRouteWithLayout
                component={NationalMethodologyPriorityActionsSection}
                exact
                layout={MainLayout}
                path="/dq_pro/national-dashboard/methodology/priority-actions"
            />
            <PrivateRouteWithLayout
                component={NationalMethodologyLearningImpactSection}
                exact
                layout={MainLayout}
                path="/dq_pro/national-dashboard/methodology/learning-impact"
            />

            <RouteWithLayout
                component={NotFoundPage}
                exact={false}
                layout={MinimalLayout}
                path="/"
            />

        </Switch>
    );
};

export default Routes;
